import React from 'react';
import './UserGroupIcon.scss';

const UserGroupIcon = () => {
  const className = 'c-UserGroupIcon';
  return (
    <svg
      className={className}
      width="14"
      height="12"
      fill="none"
      viewBox="0 0 14 12"
    >
      <path
        className={`${className}__p1`}
        d="M8.448 2.06a2.597 2.597 0 011.184 1.925c.264.125.557.197.868.197 1.134 0 2.053-.936 2.053-2.09C12.553.935 11.634 0 10.5 0 9.377 0 8.466.92 8.448 2.06zM7.103 6.342c1.134 0 2.054-.937 2.054-2.092s-.92-2.09-2.054-2.09-2.053.936-2.053 2.09c0 1.155.92 2.092 2.053 2.092zm.871.142H6.232c-1.45 0-2.629 1.202-2.629 2.678v2.17l.005.034.147.047C5.14 11.853 6.34 12 7.33 12c1.932 0 3.052-.561 3.12-.597l.138-.07h.015V9.162c0-1.477-1.18-2.678-2.629-2.678zm3.397-2.159H9.642a2.6 2.6 0 01-.78 1.795 3.174 3.174 0 012.23 3.045v.669c1.708-.064 2.691-.557 2.756-.59l.137-.07H14V7.003c0-1.477-1.18-2.678-2.629-2.678zm-7.87-.142c.401 0 .775-.12 1.091-.323.101-.669.453-1.253.956-1.65.002-.04.005-.079.005-.118C5.553.937 4.634 0 3.5 0S1.447.937 1.447 2.09c0 1.155.92 2.092 2.053 2.092zM5.343 6.12a2.6 2.6 0 01-.78-1.785c-.064-.005-.128-.01-.193-.01H2.63C1.179 4.325 0 5.526 0 7.003v2.17l.005.034.147.047c1.11.353 2.1.515 2.96.567v-.656c.001-1.437.944-2.654 2.232-3.045z"
      ></path>
    </svg>
  );
};

export default UserGroupIcon;
